import z from "zod";

/**
 * PesquisaSatisfacaoSchema
 */

export const PesquisaSatisfacaoSchema = z.object({
  pesquisa: z.coerce.number().optional(),
  pesquisas: z.array(z.coerce.number()).optional(),
});

/**
 * PesquisaSatisfacaoForm
 */

export type PesquisaSatisfacaoForm = z.infer<typeof PesquisaSatisfacaoSchema>;